export default {"src":"/_next/static/media/guided_tours.a52b7936.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};